<template lang="pug">
.cascader-container
  div.cascader-context(:class="size",
      @click.stop="openLevel1"
    )
    input(:placeholder="placeholder",
      :class="{'error': isValid}",
      v-model="showValue",
      :disabled="disabled",
      readonly)
    i.fa.fa-caret-down
  div.cascader-dropmenu
    ul.cascader-menu-level1(v-show="level1Show",
        @mousewheel="onMousewheel($event)",
        :class="size"
      )
      li.casecader-menu-item(v-for="item,index in options",
          :class="{'active': checkChildOptions(item)}",
          :title="item[showkey]",
          @click.stop="stop",
          @mouseenter="openLevel2($event, item, index)"
        )
        | {{item[showkey]}}
        span.cascader-icon
          i.fa.fa-angle-right
    ul.cascader-menu-level2(v-show="level1Show && level2Show",
        @mousewheel="onMousewheel($event)",
        :class="size",
        :style="level2Style",
        @mouseenter="clearTimer()"
      )
      li.casecader-menu-item(v-for="item in childrenOptions",
          :class="{'active': item.selected }",
          :title="item[showkey]",
          @click.stop="selectedMenu(item)"
        )
        | {{item[showkey]}}
</template>
<script>
/* global _ */
export default {
  name: 'Cascader',
  props: {
    value: [String, Number],
    disabled: Boolean,
    menu: {
      type: Array,
      default () {
        return []
      }
    },
    valid: Boolean,
    size: {
      type: String,
      default: 'small'
    },
    showkey: {
      type: String,
      default: 'title'
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      timer: '',
      showValue: '',
      isValid: false,
      menuEl: '',
      filterValue: '',
      options: [],
      childrenOptions: [],
      level2Style: {
        top: '0px'
      },
      level2Show: false,
      level1Show: false
    }
  },
  watch: {
    valid (newVal, oldVal) {
      this.isValid = newVal
    },
    value (newVal, oldVal) {
      this.showValue = this.value && !_.isEmpty(_.find(this.childrenMenu, {dim: this.value}))
        ? _.find(this.childrenMenu, {dim: this.value}).dim_desc : ''
    },
    menu (newVal) {
      this.$nextTick(() => {
        this.options = _.cloneDeep(newVal)
        this.showValue = this.value && !_.isEmpty(_.find(this.childrenMenu, {dim: this.value}))
          ? _.find(this.childrenMenu, {dim: this.value}).dim_desc : ''
      })
    }
  },
  computed: {
    childrenMenu () {
      return _.reduce(this.options, (result, item) => {
        return _.concat(result, item.childrenOptions)
      }, [])
    }
  },
  methods: {
    checkChildOptions (item) {
      return item.childrenOptions === this.childrenOptions
    },
    onMousewheel (e) {
      const elem = e.currentTarget
      const scrollTop = elem.scrollTop
      const dir = e.deltaY ? (e.deltaY < 0 ? 'up' : 'down') : void 0

      if (dir === 'up' && scrollTop <= 0) {
        return e.preventDefault()
      }

      if (dir === 'down' && (elem.clientHeight + scrollTop) === elem.scrollHeight) {
        return e.preventDefault()
      }
    },
    openLevel1 () {
      this.resize()
      this.isValid = false
      this.level1Show = !this.disabled
    },
    resize () {
      this.$nextTick(() => {
        this.menuEl.style.cssText = this.getStyle()
      })
    },
    getStyle () {
      const clientRect = this.$el.getBoundingClientRect()
      const windowH = window.innerHeight
      const marginTop = 2
      const maxHeight = 275
      const scrollHeight = document.body.scrollWidth > window.innerWidth ? 20 : 0
      let levelHeight = 30 * this.options.length
      levelHeight = levelHeight > maxHeight ? maxHeight : levelHeight
      const clientHeight = clientRect.height + marginTop
      const defaultTop = clientRect.top + clientRect.height + marginTop + window.pageYOffset
      const compTop = clientRect.top - levelHeight - window.pageYOffset
      const top = clientRect.top + clientHeight + levelHeight + scrollHeight > windowH
        ? compTop : defaultTop
      const left = clientRect.left + window.pageXOffset
      return `
        position: absolute;
        top: ${top}px;
        left: ${left}px;
        z-index: 9;
      `
    },
    clearTimer () {
      clearTimeout(this.timer)
    },
    openLevel2 (e, menuItem, index) {
      const lineHeight = 29
      const itemHeight = 30
      const maxLevel2Height = 275
      const scrollHeight = document.body.scrollWidth > window.innerWidth ? 20 : 0
      let leve2Height = itemHeight * menuItem.childrenOptions.length
      leve2Height = leve2Height > maxLevel2Height ? maxLevel2Height : leve2Height
      const clientY = e.currentTarget.getBoundingClientRect().y
      const windowH = window.innerHeight
      const scrollTop = e.currentTarget.parentElement.scrollTop
      const top = leve2Height + clientY >= windowH
        ? windowH - scrollHeight - leve2Height - clientY + lineHeight * index + scrollTop
        : lineHeight * index - scrollTop
      this.timer = setTimeout(() => {
        this.childrenOptions = menuItem.childrenOptions
        this.level2Style = {
          top: `${top}px`
        }
        this.level2Show = true
      }, 500)
    },
    selectedMenu (item) {
      this.showValue = `${item[this.showkey]}`
      this.options = this.options.map((item) => {
        item.childrenOptions = item.childrenOptions.map((item) => {
          item.selected = false
          return item
        })
        return item
      })
      this.$set(item, 'selected', true)
      this.level2Show = false
      this.level1Show = false
      this.$emit('input', item.dim)
    },
    close () {
      this.level2Show = false
      this.level1Show = false
    },
    stop () {
     return false
    }
  },
  created () {
    this.options = _.cloneDeep(this.menu)
    this.isValid = this.valid
  },
  mounted () {
    this.showValue = this.value && !_.isEmpty(_.find(this.childrenMenu, {dim: this.value}))
      ? _.find(this.childrenMenu, {dim: this.value}).dim_desc : ''
    this.menuEl = document.querySelector('.cascader-dropmenu')
    document.body.appendChild(this.menuEl)
    this.resize()
    document.addEventListener('click', this.close, true)
    window.addEventListener('resize', this.resize, false)
    window.addEventListener('scroll', this.resize, true)
  },
  destroyed () {
    this.clearTimer()
    document.removeEventListener('click', this.close, true)
    window.removeEventListener('resize', this.resize, false)
    window.removeEventListener('scroll', this.resize, true)
  }

}
</script>

<style>
.cascader-container {
  display: inline-block;
  margin-right: 5px;
}
.cascader-context.small {
    width: 120px;
}
.cascader-context.big {
    width: 240px;
}
.cascader-context {
  position: relative;
  input,
  input:not([type]):disabled {
    width: 100%;
    height: 28px;
  }
  .fa {
    position: absolute;
    right: 11px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    font-size: 14px;
    cursor: pointer;
    color: #596980;
    margin: 0;
  }
}
.cascader-menu-level1,
.cascader-menu-level2 {
    box-shadow: 0 0 5px #dadfe6;
    list-style: none;
    max-height: 274px;
    overflow-y: auto;
    border: 1px solid #DADFE6;
    border-top: 0;
    background-color: #fff;
    box-sizing: border-box;
    z-index: 99;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
    }
    &::-webkit-scrollbar-thumb {
        background: #ced3d9;
        border-radius: 10px;
        border-radius: 30px;
    }
    &::-webkit-scrollbar-track {
        background: #eaeced;
    }
    &.small {
        width: 120px;
    }
    &.big {
        width: 240px;
    }
}
.cascader-menu-level2 {
    position: absolute;
    &.small {
      left: 120px;
    }
    &.big {
      left: 240px;
      width: 120px;
    }
}
.casecader-menu-item {
    position: relative;
    border-top: 1px solid #dadfe6;
    line-height: 28px;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
    overflow: hidden;
    text-align: left;
    cursor: pointer;
    line-height: 28px;
    padding: 0 5px 0 8px;
    color: #596980;
    font-size: 12px;
    font-weight: normal;
    &.active,
    &:hover {
      background-color: #F5F8FB;
      font-weight: bold;
    }
}
.cascader-icon {
    position: absolute;
    right: 5px;
    font-size: 16px;
}

</style>



// WEBPACK FOOTER //
// cascader.vue?307b760d